<template>
  <div class="mmg-storefront mmg-contact fusion-body">
    <div id="wrapper">
      <SiteHeader />

      <div
        class="fusion-page-title-bar fusion-page-title-bar-none fusion-page-title-bar-left"
      >
        <div class="fusion-page-title-row">
          <div class="fusion-page-title-wrapper">
            <div class="fusion-page-title-captions">
              <h1 class="entry-title">{{ $t('contact.title') }}</h1>
            </div>
            <div class="fusion-page-title-secondary">
              <div class="fusion-breadcrumbs">
                <router-link to="/">{{ $t('common.home') }}</router-link>
                <span class="fusion-breadcrumb-sep">/</span>
                <span class="breadcrumb-leaf">{{ $t('contact.title') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <main id="main" role="main" class="clearfix">
        <div class="fusion-row">
          <section id="content" class="contact-content">
            <article class="page type-page status-publish hentry">
              <div class="post-content">
                <section class="fusion-fullwidth contact-section">
                  <div class="fusion-builder-row fusion-row mmg-contact-row">
                    <div
                      class="fusion-layout-column fusion-one-half fusion-column-first contact-column"
                    >
                      <div class="fusion-column-wrapper">
                        <div
                          class="fusion-title fusion-title-size-two fusion-border-below-title"
                        >
                          <h2 class="title-heading-left contact-company-title">
                            {{ $t('contact.companyName') }}
                          </h2>
                        </div>
                        <ul class="fusion-checklist contact-checklist">
                          <li
                            v-for="item in contactItems"
                            :key="item.id"
                            class="fusion-li-item"
                          >
                            <span class="icon-wrapper circle-yes">
                              <i
                                class="fusion-li-icon"
                                :class="item.icon"
                                aria-hidden="true"
                              />
                            </span>
                            <div class="fusion-li-item-content">
                              <p v-if="item.href">
                                <a :href="item.href">{{ item.text }}</a>
                              </p>
                              <p v-else>{{ item.text }}</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div
                      class="fusion-layout-column fusion-one-half fusion-column-last contact-column"
                    >
                      <div class="fusion-column-wrapper">
                        <div class="fusion-text contact-form">
                          <ContactInquiryForm />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </article>
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import ContactInquiryForm from '@/components/ContactInquiryForm.vue'
import { WHATSAPP_URL } from '@/constants/contact'

export default {
  name: 'ContactPage',
  components: { SiteHeader, SiteFooter, ContactInquiryForm },
  computed: {
    contactItems() {
      void this.currentLocale
      return [
        {
          id: 'address',
          icon: 'fa fa-home',
          text: this.$t('contact.address')
        },
        {
          id: 'email',
          icon: 'fa fa-envelope-o',
          text: 'info@borisbags.com',
          href: 'mailto:info@borisbags.com'
        },
        {
          id: 'phone',
          icon: 'fa fa-phone',
          text: '+86 18273950322',
          href: 'tel:+8618273950322'
        },
        {
          id: 'whatsapp',
          icon: 'fa fa-whatsapp',
          text: this.$t('contact.whatsappLabel'),
          href: WHATSAPP_URL
        },
        {
          id: 'website',
          icon: 'fa fa-link',
          text: 'borisbags.com',
          href: '/'
        }
      ]
    }
  },
  mounted() {
    document.title = this.$t('pageTitle.contact')
    document.body.classList.add('contact')
  },
  watch: {
    currentLocale() {
      document.title = this.$t('pageTitle.contact')
    }
  },
  beforeUnmount() {
    document.body.classList.remove('contact')
  }
}
</script>

<style scoped>
.contact-content {
  width: 100%;
}

.contact-section {
  padding: 20px 0;
}

.contact-company-title {
  margin: 0 0 31px;
  font-size: 30px;
  font-weight: 400;
  color: var(--mmg-heading, #333);
}
</style>
